import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import updateRoutes from "./services/getRoutes";

Vue.use(Router);

let updated = false;

let router = new Router({
  routes: []
});

// Redirigir a inicio si no está validado
router.beforeEach((to, from, next) => {
  if (updated === false) {
    updated = true;
    store.dispatch("setCargandoRuta", true);
    updateRoutes()
      .then(data => {
        router.addRoutes(data);
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        store.dispatch("setCargandoRuta", false);
      });
  }
  next();
});

export default router;
